import EbisDateRangePicker from 'views/molecules/calendar/EbisDateRangePicker';

export default EbisDateRangePicker;
